import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47cdbe70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "interview-prep-container" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-state mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-video display-1 text-muted" }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 mb-2" }, "No Interview Prep Generated Yet"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " Select generate to create your personalized interview preparation materials ")
], -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-magic me-2" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_11 = { class: "card main-card glass-morphism mb-4" }
const _hoisted_12 = { class: "company-header" }
const _hoisted_13 = { class: "company-title-wrapper" }
const _hoisted_14 = { class: "company-name" }
const _hoisted_15 = { class: "position-badge" }
const _hoisted_16 = { class: "company-description" }
const _hoisted_17 = { class: "card glass-morphism mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square text-primary" }),
    /*#__PURE__*/_createElementVNode("h2", null, "Key Responsibilities")
  ])
], -1))
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "responsibilities-list" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-short text-primary" }, null, -1))
const _hoisted_22 = { class: "card glass-morphism mb-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trophy-fill text-primary" }),
  /*#__PURE__*/_createElementVNode("h2", null, "Required Skills")
], -1))
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "skills-grid" }
const _hoisted_26 = { class: "card glass-morphism mb-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left-text-fill text-primary" }),
  /*#__PURE__*/_createElementVNode("h2", null, "Practice Questions")
], -1))
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "questions-accordion" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "question-count" }
const _hoisted_32 = { class: "category-content" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "answer-content" }
const _hoisted_35 = {
  key: 0,
  class: "star-answer"
}
const _hoisted_36 = { class: "star-label" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "card glass-morphism mb-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square text-primary" }),
  /*#__PURE__*/_createElementVNode("h2", null, "Questions to Ask")
], -1))
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "interviewer-questions-list" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle text-primary" }, null, -1))

import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ResponseApiService } from "@/services/ResponseApiService";
import type { InterviewPrepSchema } from "@models/interviewPrep";
import BreadcrumbNav from "@/components/BreadcrumbNav.vue";
import { toast } from "vue3-toastify";

// Initialize all sections as expanded by default

export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewPrepView',
  setup(__props) {

const isExpanded = ref({
  skills: true,
  questions: true,
  interviewer: true,
});

// Initialize expandedCategories as a reactive object
const expandedCategories = ref<{ [key: string]: boolean }>({});

// Initialize questionStates to track individual question expansion
const questionStates = ref<{ [key: string]: boolean }>({});

const route = useRoute();
const loading = ref(false);

// Compute required skills
const requiredSkills = computed(() => {
  return interview.value?.keyResponsibilities || [];
});

const interview = ref<InterviewPrepSchema>({
  company: "",
  jobTitle: "",
  companySummary: "",
  role: "",
  skillsAndQualifications: [],
  questionsAndAnswers: [],
  questions: [],
  keyResponsibilities: [], // Add this if it's in your schema
});

// Toggle functions
const toggleSection = (section: keyof typeof isExpanded.value) => {
  isExpanded.value[section] = !isExpanded.value[section];
};

const toggleCategory = (categoryName: string) => {
  expandedCategories.value[categoryName] = !expandedCategories.value[categoryName];
};

const toggleQuestion = (questionId: string) => {
  questionStates.value[questionId] = !questionStates.value[questionId];
};

// Rest of your existing code...
onMounted(async () => {
  loading.value = true;
  try {
    const applicationId = route.params.id as string;
    const response = await ResponseApiService.getInterviewPrepForApplication(applicationId);

    if (response.status === 200 && response.data) {
      interview.value = response.data;

      // Initialize category states
      if (response.data.questionsAndAnswers) {
        response.data.questionsAndAnswers.forEach((qa: any) => {
          const category = qa.category || "General";
          expandedCategories.value[category] = true;
          // Initialize question states
          questionStates.value[qa.id || qa.question] = false;
        });
      }
    }
  } catch (error) {
    console.error("Error fetching interview prep:", error);
    toast.error("Failed to load interview preparation materials");
  } finally {
    loading.value = false;
  }
});

async function generatePrep() {
  loading.value = true;
  try {
    const applicationId = route.params.id as string;
    const response = await ResponseApiService.generateInterviewPrep(applicationId);

    if (response.status === 200) {
      interview.value = response.data;
      toast.success("Interview prep materials generated successfully!");
    }
  } catch (error) {
    console.error("Error generating interview prep:", error);
    toast.error("Failed to generate interview preparation materials");
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadcrumbNav, {
      "back-link": `/application/${_unref(route).params.id}`,
      "back-text": "Application",
      "current-page": "Interview Prep",
      class: "mb-4"
    }, null, 8, ["back-link"]),
    _createElementVNode("div", _hoisted_1, [
      (!interview.value.company)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              onClick: generatePrep,
              class: "btn btn-primary btn-lg",
              disabled: loading.value
            }, [
              (!loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(" Generate Interview Prep ")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            ], 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h1", _hoisted_14, _toDisplayString(interview.value.company), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(interview.value.jobTitle), 1)
                ]),
                _createElementVNode("p", _hoisted_16, _toDisplayString(interview.value.companySummary), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("ul", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interview.value.keyResponsibilities, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "responsibility-item"
                    }, [
                      _hoisted_21,
                      _createTextVNode(" " + _toDisplayString(item.responsibility), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: "card-header clickable",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSection('skills')))
              }, [
                _hoisted_23,
                _createElementVNode("i", {
                  class: _normalizeClass(['bi', isExpanded.value.skills ? 'bi-chevron-up' : 'bi-chevron-down'])
                }, null, 2)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interview.value.skillsAndQualifications, (skill, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["skill-item", skill.required.toLowerCase()])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([
                  'bi',
                  skill.required === 'Required'
                    ? 'bi-check-circle-fill text-success'
                    : 'bi-star-fill text-warning',
                ])
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(skill.item), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["badge", skill.required.toLowerCase()])
                      }, _toDisplayString(skill.required), 3)
                    ], 2))
                  }), 128))
                ])
              ], 512), [
                [_vShow, isExpanded.value.skills]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", {
                class: "card-header clickable",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSection('questions')))
              }, [
                _hoisted_27,
                _createElementVNode("i", {
                  class: _normalizeClass(['bi', isExpanded.value.questions ? 'bi-chevron-up' : 'bi-chevron-down'])
                }, null, 2)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interview.value.questionsAndAnswers, (questionGroup) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: questionGroup.type,
                      class: "category-section"
                    }, [
                      _createElementVNode("div", {
                        class: "category-header clickable",
                        onClick: ($event: any) => (toggleCategory(questionGroup.type))
                      }, [
                        _createElementVNode("h3", null, [
                          _createTextVNode(_toDisplayString(questionGroup.type) + " ", 1),
                          _createElementVNode("span", _hoisted_31, "(" + _toDisplayString(questionGroup.questions.length) + ")", 1)
                        ]),
                        _createElementVNode("i", {
                          class: _normalizeClass([
                    'bi',
                    expandedCategories.value[questionGroup.type] ? 'bi-chevron-up' : 'bi-chevron-down',
                  ])
                        }, null, 2)
                      ], 8, _hoisted_30),
                      _withDirectives(_createElementVNode("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionGroup.questions, (qa, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "question-item"
                          }, [
                            _createElementVNode("div", {
                              class: "question-header clickable",
                              onClick: ($event: any) => (toggleQuestion(`${questionGroup.type}-${index}`))
                            }, [
                              _createElementVNode("h4", null, _toDisplayString(qa.question), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass([
                        'bi',
                        questionStates.value[`${questionGroup.type}-${index}`]
                          ? 'bi-chevron-up'
                          : 'bi-chevron-down',
                      ])
                              }, null, 2)
                            ], 8, _hoisted_33),
                            _withDirectives(_createElementVNode("div", _hoisted_34, [
                              (qa.answer.isStarAnswer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.answer.starAnswer, (content, part) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: part,
                                        class: "star-section"
                                      }, [
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(part), 1),
                                        _createElementVNode("p", null, _toDisplayString(content), 1)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(qa.answer.answer), 1))
                            ], 512), [
                              [_vShow, questionStates.value[`${questionGroup.type}-${index}`]]
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, expandedCategories.value[questionGroup.type]]
                      ])
                    ]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, isExpanded.value.questions]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", {
                class: "card-header clickable",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSection('interviewer')))
              }, [
                _hoisted_39,
                _createElementVNode("i", {
                  class: _normalizeClass(['bi', isExpanded.value.interviewer ? 'bi-chevron-up' : 'bi-chevron-down'])
                }, null, 2)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_40, [
                _createElementVNode("ul", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interview.value.questions, (question, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "question-item"
                    }, [
                      _hoisted_42,
                      _createTextVNode(" " + _toDisplayString(question.question), 1)
                    ]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, isExpanded.value.interviewer]
              ])
            ])
          ]))
    ])
  ], 64))
}
}

})